export default {
  data() {
    return {
      tableHeight: 600,
      tableRef: null,
      tableIntersectionObserver: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      const tables = [...this.$el.querySelectorAll('.vxe-table')]
      this.tableRef = tables.find(
        t => [...t.parentElement.classList].indexOf('sort-fields-popover') < 0
      )

      // 创建当前元素基于父元素可视化状态监控
      this.tableIntersectionObserver = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            // 如果表格是显示的, 则获取表格高度并添加窗口的resize事件监听
            this.getHeight()
          }
        },
        {
          root: this.$el.parentElement
        }
      )
      this.tableIntersectionObserver.observe(this.tableRef)
    })
    this.addResizeListener()
  },
  destroyed() {
    this.removeResizeListener()
    this.tableIntersectionObserver.disconnect()
  },
  methods: {
    getHeight() {
      if (!this.tableRef.offsetHeight) return
      setTimeout(() => {
        // 此处使用bottom是为了兼容作为子应用运行时的显示效果
        const {
          bottom: windowHeight
        } = document.documentElement.getBoundingClientRect()

        const { top = 0 } = this.tableRef.getBoundingClientRect() || {}

        this.tableHeight = windowHeight - top
      }, 200)
    },
    addResizeListener() {
      this.removeResizeListener()
      window.addEventListener('resize', this.getHeight)
    },
    removeResizeListener() {
      window.removeEventListener('resize', this.getHeight)
    }
  }
}